"use strict";

const _ = require('lodash');
const apiClient = require('./api-client');
const al = require('./alert');


let alertController = new al.AlertController({
	id: 'cm-alert-health',
	message:
		'Stored data is currently being reprocessed due to a software change.<br>' +
		'Until this is complete, displayed totals may not accurately reflect the current data.'
});

module.exports = function showHealth(fields, callback = _.noop) {
	apiClient.apiCall({method: 'health'}, function (err, response) {
		if (!err) {
			console.info('Health status', response.healthStatus);
			let processorsHealth = _.get(response, 'healthStatus.processors', {});
			let healthStatus = true;
			for (let f of _(fields).flatten().compact()) {
				if (!processorsHealth[f]) {
					healthStatus = false;
					break;
				}
			}
			if (!healthStatus) {
				alertController.render();
			} else {
				alertController.destroy();
			}
		} else {
			console.error(err, response);
		}
		callback(err, response);
	});
};
